import React, { useState, useEffect } from "react";

import Select from "../../components/Select";

import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

function GetCoaches({
  defaultItem,
  userId,
  handleChange,
  value,
  className,
  isCampaign,
  style,
  getCoachList,
  ...props
}) {
  const coach_id = userId ? userId : getLocalValue("uid");
  const level_id = getLocalValue("u_levelid");
  const [coachList, setCoachList] = useState([]);

  useEffect(() => {
    getCoaches();
  }, [isCampaign]);

  const getCoaches = () => {
    const campainParam = isCampaign ? `&campaign_id=${isCampaign}` : "";
    apiRequest
      .get(
        `/api/getCoaches?uid=${coach_id}&level_id=${level_id}${campainParam}`
      )
      .then(response => {
        if (response.status === 200) {
          let data =
            response.data && response.data.data ? response.data.data : [];
          if (data.length > 0) {
            data = data.map(item => {
              return {
                value: item.uid,
                label: item.u_fullname,
                ...item,
              };
            });
            if (defaultItem) {
              data.push(defaultItem);
            }
            setCoachList(data);
            if (getCoachList) {
              getCoachList(data);
            }
          }
        }
      })
      .catch(error => {});
  };

  return (
    <div style={{ display: `${style ? style : "unset"}` }}>
      {coachList && (
        <Select
          className={className}
          list={coachList}
          searchable={true}
          value={value}
          onChange={e => {
            handleChange(e.target.value);
          }}
        />
      )}
    </div>
  );
}

export default GetCoaches;
